import React from 'react';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeferContext = React.createContext(null);
/**
 * This function will ask the browser for an animation frame
 * then when granted, it will subscribe to a timeout with a delay to execute a registration callback
 * this function returns an object containing the request animation frame id and the timeout id
 * It is important to return them for clean up purposes.
 */

function standaloneRegister(registration, delay) {
  var registrationData = {
    rafId: null,
    timeoutId: null
  };
  registrationData.rafId = window.requestAnimationFrame(function () {
    registrationData.timeoutId = setTimeout(registration, delay);
  });
  return registrationData;
}
/**
 * This function will clear a timeout and an animation frame id
 */


function standaloneCleanUp(_ref) {
  var timeoutId = _ref.timeoutId,
      rafId = _ref.rafId;
  window.clearTimeout(timeoutId);
  window.cancelAnimationFrame(rafId);
}
/**
 * This hoc defers the render of a component
 * aka:
 * - The first time your component renders, this HOC will render nothing instead
 * - After the paint, your component will render
 * This allows the important parts of the screen to be visible first
 * and later (basically instantly) have the other parts
 *
 *
 * This HOC works with two modes:
 * 1 - Standalone Mode: this means, that the Deferred component doesn't have any DeferContextProvider Parent
 * 2 - Placed in a DeferContextProvider tree; this means that the render of your component is managed by the provider
 *
 * How are the two modes different ?
 * The only differences is that:
 * 1- In standalone mode; the registration function asks instantly/directly
 *    the browser for an animation frame then renders when grated.
 *    The registration function is the `standaloneRegister` declared within this file.
 *    Meanwhile in the controlled mode, it will obey the provider config
 * 2- If you have a lot of deferred components, you may gain nothing from deferring the render
 *    and the user may experience some LAG and cannot fire any event unless the main thread is empty
 *    Meanwhile in context mode, you can specify the sequential mode with a variable delay if some of the components are outside the view port
 */


function withDeferRender(WrappedComponent, config) {
  return function WithDeferRender(props) {
    /**
     * First, we retrieve the DeferContext value
     * Then we will try to init the register, next and cleanUp functions
     */
    var contextValue = React.useContext(DeferContext);
    var register = (contextValue === null || contextValue === void 0 ? void 0 : contextValue.register) || standaloneRegister;
    var next = contextValue === null || contextValue === void 0 ? void 0 : contextValue.next;
    var cleanUp = (contextValue === null || contextValue === void 0 ? void 0 : contextValue.cleanUp) || standaloneCleanUp;
    /**
     * Initially, the component isn't allowed to render
     * unless the shouldRender become true
     */

    var _React$useState = React.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        shouldRender = _React$useState2[0],
        setShouldRender = _React$useState2[1];

    React.useEffect(function () {
      /** register the component with a callback that sets the shouldRender state to true **/
      var registrationData = register(function () {
        return setShouldRender(true);
      });
      /** when the component gets unmounted for some reason; it s important to clean the subscriptions **/

      return function () {
        return cleanUp(registrationData);
      };
    }, []);
    React.useEffect(function () {
      /**
       * The first time the component renders correctly
       * And if inside a context (next is a function)
       * We call the next to notify the context that we are willing to render the next components
       */
      if (shouldRender && typeof next === 'function') {
        next();
      }
    }, [shouldRender]);

    if (!shouldRender) {
      // if there is a fallback; render it; for example a circular progress or a placeholder
      return (config === null || config === void 0 ? void 0 : config.fallback) || null;
    }

    return React.createElement(WrappedComponent, props);
  };
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.fundamental") : 60117,
      w = b ? Symbol.for("react.responder") : 60118,
      x = b ? Symbol.for("react.scope") : 60119;

  function y(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case d:
          return u;
      }
    }
  }

  function z(a) {
    return y(a) === m;
  }

  exports.typeOf = y;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = t;
  exports.Memo = r;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w || a.$$typeof === x);
  };

  exports.isAsyncMode = function (a) {
    return z(a) || y(a) === l;
  };

  exports.isConcurrentMode = z;

  exports.isContextConsumer = function (a) {
    return y(a) === k;
  };

  exports.isContextProvider = function (a) {
    return y(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return y(a) === n;
  };

  exports.isFragment = function (a) {
    return y(a) === e;
  };

  exports.isLazy = function (a) {
    return y(a) === t;
  };

  exports.isMemo = function (a) {
    return y(a) === r;
  };

  exports.isPortal = function (a) {
    return y(a) === d;
  };

  exports.isProfiler = function (a) {
    return y(a) === g;
  };

  exports.isStrictMode = function (a) {
    return y(a) === f;
  };

  exports.isSuspense = function (a) {
    return y(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE);
      }
      /**
       * Forked from fbjs/warning:
       * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
       *
       * Only change is we use console.warn instead of console.error,
       * and do nothing when 'console' is not supported.
       * This really simplifies the code.
       * ---
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var lowPriorityWarningWithoutStack = function lowPriorityWarningWithoutStack() {};

      {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.warn(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        lowPriorityWarningWithoutStack = function lowPriorityWarningWithoutStack(condition, format) {
          if (format === undefined) {
            throw new Error('`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(void 0, [format].concat(args));
          }
        };
      }
      var lowPriorityWarningWithoutStack$1 = lowPriorityWarningWithoutStack;

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            lowPriorityWarningWithoutStack$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.typeOf = typeOf;
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isValidElementType = isValidElementType;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
    })();
  }
});
unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

/**
 * represents the work status
 */
var __WORK_STATUS = {
  IDLE: 0,
  PAUSED: 1,
  WORKING: 2
};
/**
 * The only three modes supported by the provider
 */

var __DEFER_MODES = {
  SEQUENTIAL: 'sequential',
  SYNC: 'sync',
  ASYNC_CONCURRENT: 'async-concurrent'
};
/**
 * just returns a work object to be saved in the context
 */

function makeNewWork(work, index) {
  return {
    work: work,
    index: index,
    ready: false,
    done: false,
    timeoutId: null,
    rafId: null
  };
}
/**
 * This is the defer render context provider that will manage deferring many of your components.
 *
 * It wraps your components with a DeferContext.Provider while giving as value the following:
 * - register: will register a callback to be called when the time comes
 * - next: will invoke the next callback if idle
 * - pause: will pause the work
 * - resume: will resume the work
 * - cleanUp: will unsubscribe a work a delete it from context
 *
 *
 * @param delay: number. The delay in ms after which the subscribed component is rendered
 * @param batchSize: number, In async-concurrent and sync modes; we can batch subscribers
 * @param mode: string. one of sync, sequential, async-concurrent
 * @param children: ReactNode. the children of context
 */


function DeferRenderProvider(_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      batchSize = _ref.batchSize,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? __DEFER_MODES.SEQUENTIAL : _ref$mode,
      children = _ref.children;
  /**
   * Work status inside Provider
   * IDLE: ready to work
   * WORKING: actually working on deferring the render of subscribed components
   * PAUSED: work is interrupted and provider isn't doing anything
   */

  var workStatus = React.useRef(__WORK_STATUS.IDLE);
  /**
   * Used to identify works
   * it's given to a work after the subscription
   */

  var indexTracker = React.useRef(0);
  /**
   * The work queue: contains the work to be done
   */

  var workQueue = React.useRef([]);
  /**
   * The work that it's currently ongoing
   * How it's different from the queue ?
   * Depending on the Defer mode, the provider slices the batchSize from the work queue
   * and places it the current work and then triggers the work
   */

  var currentWorkQueue = React.useRef([]);
  /**
   * The provider should not relay on the values of { delay, batchSize, deferMode } from props
   * Because the provider will register the work with the old values provided from the initial render closure
   * So we use refs to track them: if they change, the ref's value will change also and the new values will be taken
   */

  var delayRef = React.useRef(delay);

  if (delayRef.current !== delay) {
    delayRef.current = delay;
  }

  var modeRef = React.useRef(mode);

  if (modeRef.current !== mode) {
    modeRef.current = mode;
  }

  var batchSizeRef = React.useRef(batchSize);

  if (batchSizeRef.current !== batchSize) {
    batchSizeRef.current = batchSize;
  }
  /**
   * This function will create a new work with a new index
   *
   * It is important to note that this function is used to subscribe deferred components
   * and should return an identifier that will used in the clean-up function
   */


  function register(work) {
    /**
     * The index tracker is used to identify works
     * it is basically an auto-increment integer value
     */
    var newWork = makeNewWork(work, ++indexTracker.current);
    /** add the work to the queue **/

    workQueue.current.push(newWork);
    /**
     * If the work queue contains only one element, asynchronously trigger the work
     * So after the first registration the work will begin
     *
     * It is important to run it asynchronously in a setTimeout function
     * this will give the main thread the time to register all deferred components' work
     * before starting the work so we won't start the work for one element immediately
     */

    if (workQueue.current.length === 1) {
      setTimeout(next);
    }
    /** The work index will be given to the clean up function to identify which work to clean */


    return newWork.index;
  }
  /**
   * With the asynchronous behavior of components' subscription and the work being randomly executed in several ways
   * It is important to control the work status
   * this function will only set the work status to idle if there is no more work in the current work queue
   */


  function reconcileWorkStatus() {
    if (currentWorkQueue.current.length === 0 && workStatus.current !== __WORK_STATUS.PAUSED) {
      workStatus.current = __WORK_STATUS.IDLE;
      next();
    }
  }
  /**
   * This function will remove a work entirely from both the work queue and the current work queue
   * It is executed after a work is done
   * So basically; after a work is done, it is immediatly removed and the work status is reconciled
   */


  function removeWork(work) {
    workQueue.current = workQueue.current.filter(function (t) {
      return t.index !== work.index;
    });
    currentWorkQueue.current = currentWorkQueue.current.filter(function (t) {
      return t.index !== work.index;
    });
    reconcileWorkStatus();
  }
  /**
   * This is actually the work
   * it will trigger the registered work (basically the setShouldRender to true)
   * flags the work as Done then removes it
   * Why flagging it as done then removing it ? because of the asynchronous behavior of the entire js event loop
   * the work, if not done, may be executed from a next call from a previously rendered component
   * All defer modes pass through this function
   */


  function commitWork(work) {
    work.work();
    work.done = true;
    removeWork(work);
  }
  /**
   * This function is executed in both modes: SEQUENTIAL and ASYNC_CONCURRENT
   */


  function asyncProcessCurrentWork() {
    /** the work status need to be either idle or working, if paused, we should do nothing **/
    if (workStatus.current !== __WORK_STATUS.PAUSED) {
      /** flag the work status as working **/
      workStatus.current = __WORK_STATUS.WORKING;
      currentWorkQueue.current.forEach(function (work) {
        /**
         * It is important to mutate the work and remember the both the window animation frame and the timeout id
         * Because if the tree get's unmounted (or a single component) we need to unsubscribe from these events
         * Saving both IDs in the work will allow the work to be it's single source of truth
         */
        work.rafId = window.requestAnimationFrame(function () {
          work.timeoutId = setTimeout(function () {
            return commitWork(work);
          }, delayRef.current);
        });
      });
    }
  }
  /**
   * This function is executed when using the sync defer mode
   */


  function processCurrentWork() {
    if (workStatus.current !== __WORK_STATUS.PAUSED) {
      workStatus.current = __WORK_STATUS.WORKING; // will immediately commit all work in the current work queue.
      // aka: the sliced batchSize from the remaining work in the queue

      currentWorkQueue.current.forEach(commitWork);
    }
  }
  /**
   * This function is called only from the `next` function
   * but it is the main function of the provider
   * depending on the defer mode, will execute the corresponding function (processCurrentWork or asyncProcessCurrentWork)
   */


  function beginWork() {
    /** immediately exit if there is no work in the main queue **/
    if (workQueue.current.length === 0) {
      return;
    }
    /** flag the work as working **/


    workStatus.current = __WORK_STATUS.WORKING;
    /**
     * In the sequential work mode; the provider renders only one component at a time
     * each deferred component after rendering, calls the next function
     */

    if (modeRef.current === __DEFER_MODES.SEQUENTIAL) {
      /** add work to the current work queue only if there is no ongoing work **/
      if (currentWorkQueue.current.length === 0) {
        /** grab the first work from the queue, flag it as ready, then push it in the current work queue **/
        var nextWork = workQueue.current[0];
        nextWork.ready = true;
        currentWorkQueue.current.push(nextWork);
      }

      asyncProcessCurrentWork();
      /**
       * In the synchronous mode of deferring, a bunch of work is executed simultaneously
       * say we have a batch size of 10, and a delay of 100, this means
       * each 100 millis, 10 components will be printed to the screen at the same time
       */
    } else if (modeRef.current === __DEFER_MODES.SYNC) {
      if (currentWorkQueue.current.length === 0) {
        var _currentWorkQueue$cur;
        /** take either the batch size or the whole work and send it to the current work queue **/


        var _nextWork = workQueue.current.slice(0, batchSizeRef.current || workQueue.current.length);

        (_currentWorkQueue$cur = currentWorkQueue.current).push.apply(_currentWorkQueue$cur, _toConsumableArray(_nextWork));

        currentWorkQueue.current.forEach(function (t) {
          t.ready = true;
        });
      }

      setTimeout(processCurrentWork, delayRef.current);
      /**
       * in the concurrent asynchronous mode, we slice some work
       * say we have a batch size of 10, and a delay of 100, this means
       * each 100 millis, 10 components will be printed to the screen, but they may not be printed at the same time
       */
    } else if (modeRef.current === __DEFER_MODES.ASYNC_CONCURRENT) {
      if (currentWorkQueue.current.length === 0) {
        var _currentWorkQueue$cur2;
        /** take either the batch size or the whole work and send it to the current work queue **/


        var _nextWork2 = workQueue.current.slice(0, batchSizeRef.current || workQueue.current.length);

        (_currentWorkQueue$cur2 = currentWorkQueue.current).push.apply(_currentWorkQueue$cur2, _toConsumableArray(_nextWork2));

        currentWorkQueue.current.forEach(function (t) {
          t.ready = true;
        });
      }

      asyncProcessCurrentWork();
    }
  }
  /**
   * This is the entry-point of all work; it only checks that the work status is idle and that there is something the queue, then triggers the beginWork function
   * This function is also called each time a deferred component renders
   */


  function next() {
    if (workStatus.current === __WORK_STATUS.IDLE && workQueue.current.length > 0) {
      beginWork();
    }
  }
  /**
   * If a tree get unmounted, it is important to remove all the associated work to avoid calling the callback
   * after we are granted the animation frame or the timeout resolves
   */


  function cleanUp(index) {
    /** grab the work given the identifier we are trying to remove **/
    var fromCurrent = currentWorkQueue.current.find(function (t) {
      return t.index === index;
    });
    /**
     * the only relevant unsubscription from the animation frame and/or the timeout is when the work is ready and not done yet
     */

    if (fromCurrent && fromCurrent.ready && !fromCurrent.done) {
      window.cancelAnimationFrame(fromCurrent === null || fromCurrent === void 0 ? void 0 : fromCurrent.rafId);
      clearTimeout(fromCurrent === null || fromCurrent === void 0 ? void 0 : fromCurrent.timeoutId);
    }
    /** Remove the work from both queues **/


    removeWork({
      index: index
    });
  }
  /**
   * To pause a work, it is only necessary to flag the work status as PAUSED
   * todo: unsubscribe from the animation frame and/or the timeout and remove the work only from the currentWorkQueue
   */


  function pause() {
    workStatus.current = __WORK_STATUS.PAUSED;
  }
  /**
   * To resume the work, we need to flag the status as idle then call next
   */


  function resume() {
    workStatus.current = __WORK_STATUS.IDLE;
    next();
  }
  /**
   * After each provider render, it will trigger the work
   */


  React.useEffect(function () {
    next();
  });
  return React.createElement(DeferContext.Provider, {
    value: {
      next: next,
      pause: pause,
      resume: resume,
      cleanUp: cleanUp,
      register: register
    }
  }, children);
}

export { DeferContext, DeferRenderProvider, withDeferRender };